<template>
<div class="d-block">
  <!-- <nav aria-label="breadcrumb"> -->
  <!-- <ol class=""> -->
  <span v-for="crumb in crumbs">
    <span v-if="crumb.path" @click="goto(crumb.path)">
      <span class="crumb">{{crumb.title}}</span>
      <span style="color:grey"> / </span>
    </span>
    <span style="color:grey" v-if="!crumb.path" aria-current="page">{{crumb.title}}</span>
  </span>
  <!-- <span class="crumb"><a>Library </a></span> / -->
  <!-- </ol> -->
  <!-- </nav> -->


</div>


</div>

</div>
</template>


<script>
export default {
  name: 'Home',
  props: ['crumbs', 'colour'],
  data: function() {
    return {
      // crumbs: {},
      // page: ''
    }
  },

  // created: function() {
  //   this.getData()
  // },
  // watch: {
  //   '$route': 'getData'
  // },
  components: {},
  computed: {
    // page: function() {
    //   if (this.crumbs) {
    //     // return 'wh'
    //     return this.crumbs[this.crumbs.length - 1].title
    //   }
    //   // return this.crumbs[-1]
    // }
  },
  methods: {
    goto: function(path) {
      let fullPath = ''
      for (let crumb of this.crumbs) {
        // console.log(crumb)
        fullPath += '/' + crumb.path
        if (crumb.path === path) {
          break
        }
      }
      console.log(fullPath)

      this.$router.push({ path: fullPath }).catch(err => {})
    }
    // getData: function() {
    // },
  }
}
</script>
